import { render, staticRenderFns } from "./billings-assigment-cost-budget.vue?vue&type=template&id=0583a7f6&scoped=true"
import script from "./billings-assigment-cost-budget.vue?vue&type=script&lang=js"
export * from "./billings-assigment-cost-budget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0583a7f6",
  null
  
)

export default component.exports